module.exports = __webpack_public_path__ + "static/media/bKash-gray.d1f83b8e.svg";